import { render, staticRenderFns } from "./PeixunDia.vue?vue&type=template&id=a32502aa&scoped=true"
import script from "./PeixunDia.vue?vue&type=script&lang=js"
export * from "./PeixunDia.vue?vue&type=script&lang=js"
import style0 from "./PeixunDia.vue?vue&type=style&index=0&id=a32502aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32502aa",
  null
  
)

export default component.exports